import React, { useContext, useEffect, useState } from 'react'
import styles from './PlayerStatusCard.module.css'
import { baseUrl, dataContext } from '../../../App';
import { convertToBengaliNumber } from '../helper';
import axios from 'axios';
import { fetchProfileExtraData } from '../../../services';
import handleImageError from '../../../helper/defaultImage';

const PlayerStatusCard = ({data}) => {
  const {token,extraData, setExtraData} = useContext(dataContext);
  useEffect(() => {
    if(!token) return;
    fetchProfileExtraData(token).then((res) => {
      console.log(res);
      setExtraData(res);
    });
  }, [token,data]);
  if(!data?.id) return <></>;
  return (<div className={styles.playerStatusCardContainer}>
    <div className={styles.playerStatusCard}>
      <div className={styles.header}>
        <div className={styles.userInfo}>
          <img src={data?.avatar_img
                    ? `${baseUrl}${data?.avatar_img}`
                    : require(`../../../assets/avatar/avatar${data?.avatar_id || 1}.png`)} alt="avatar"
                     className={styles.avatar} onError={handleImageError} />
          <div className={styles.nameContainer}>
            <h3>{data?.name || `0${data?.msisdn}`} 🔥</h3>
            <p>শব্দ মিলাও পুরস্কার জিতো</p>
          </div>
        </div>
        <div 
          className={`${styles.subscriptionBadge} ${(!data.isSubscribe && !data.isSubscribeSpellingBee && !data.isSubscribeMemoryMatch) ? styles.unsubscribed : ''}`}
        >
          {data.isSubscribe || data.isSubscribeSpellingBee || data.isSubscribeMemoryMatch ? 'সাবস্ক্রাইবড' : 'আনসাবস্ক্রাইবড'}
        </div>
      </div>
      
    </div></div>
  )
}

export default PlayerStatusCard